import React from 'react';
import ColorSwatch from 'components/colorSwatch/color-swatch';
import { getActiveIcon } from 'library/helpers';
import { DocLink, DocPages } from 'components/Help/';
import LegTypeFormInput from './input';

const config = {
  init: {
    color: '#000',
    is_workable: true
  },
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'Colour',
        dataIndex: 'color',
        sorter: false,
        width: '110px',
        align: 'center',
        render: (text, record) => (<ColorSwatch value={record.color} />)
      },
      {
        title: 'Is Workable',
        dataIndex: 'is_workable',
        width: '220px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [
          {
            text: 'Active',
            value: true
          },
          {
            text: 'Inactive',
            value: false
          }
        ],
        render: (text, record) => getActiveIcon(record.is_workable)
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the leg type
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      }
    },
    // General
    title: <DocLink page={DocPages.availabilityLegType}>Leg Types</DocLink>
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Leg Type',
    title: 'Leg Type',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <LegTypeFormInput
            {...props}
            title="Leg Type"
          />
        )
      }
    ]
  }
};

export default config;
